export const groupItems = ({ items, isNew }) => {
  let categories = [];

  items.map(item => {
    let index = categories.findIndex(c => c.name === item.area);
    if (index >= 0) {
      categories[index].items.push({ ...item, id: isNew ? null : item.id })
    } else {
      categories.push({ name: item.area, items: [{ ...item, id: isNew ? null : item.id }] })
    }
  });

  return categories
}